var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useRef } from 'react';
import { Icon } from '../Icon';
import { Loader } from '../Loading';
import '../../../shared/css/Button.css';
import '../../../shared/css/generic-styles.css';
import { useThemeable } from '../ProviderStyleAccess';
import { useViewportSize } from '../ProviderResponsive';
var ButtonInner = function (props, ref) {
    var iconLeading = props.iconLeading, iconTrailing = props.iconTrailing, _a = props.variant, variant = _a === void 0 ? 'secondary' : _a, _b = props.type, type = _b === void 0 ? 'button' : _b, title = props.title, small = props.small, stacked = props.stacked, onClick = props.onClick, url = props.url, _c = props.width, width = _c === void 0 ? 'fill' : _c, _d = props.loading, loading = _d === void 0 ? false : _d, _e = props.style, style = _e === void 0 ? {} : _e, children = props.children, className = props.className, _f = props.target, target = _f === void 0 ? '_self' : _f, onFileUpload = props.onFileUpload, iconLeadingColorCustom = props.iconLeadingColorCustom;
    // const theButtonStyles = getButtonStylesObject(useThemeable())
    var fileInputRef = useRef(null);
    var _g = useThemeable(), size = _g.size, space = _g.space, textStyle = _g.textStyle;
    var spacingMode = useViewportSize().spacingMode;
    var buttonStyles = {
        margin: spacingMode === 'normal'
            ? "".concat(space.vUnify + space.vExtra, "px ").concat(space.hUnify + space.hExtra, "px")
            : "".concat(space.vUnify, "px ").concat(space.hUnify, "px"),
    };
    var generateDefaultAriaLabel = function () {
        var baseLabel = title || "".concat(title || "", " ").concat(title || "").trim();
        return loading ? "".concat(baseLabel, ", is loading") : baseLabel;
    };
    var ariaLabel = loading && props.ariaLoadingLabel
        ? props.ariaLoadingLabel
        : (props.ariaLabel || generateDefaultAriaLabel());
    var ariaProps = {
        'aria-label': ariaLabel,
        'aria-busy': loading
    };
    var handleClick = function (event) {
        if (type === 'submit') {
            event.preventDefault();
        }
        if (onClick) {
            //@ts-ignore
            onClick(event);
        }
        // Trigger file input click when button is clicked
        if (onFileUpload && fileInputRef.current) {
            fileInputRef.current.click();
        }
    };
    var handleFileChange = function (event) {
        var _a;
        var file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (file && onFileUpload) {
            onFileUpload(file);
        }
    };
    var iconColors = {
        'primary': 'on-primary',
        'accent': 'on-accent',
        'secondary': 'icon',
        'tertiary': 'primary',
        'tertiary-preferred': 'primary',
        'quaternary': 'icon',
        'destructive': 'negative',
        'readOnly': 'read-only'
    };
    var loadingColors = {
        'primary': '--ts-color-on-primary',
        'accent': '--ts-color-on-accent',
        'secondary': '--ts-color-icon',
        'tertiary': '--ts-color-icon',
        'tertiary-preferred': '--ts-color-icon',
        'quaternary': '--ts-color-icon',
        'destructive': '--ts-color-icon',
        'readOnly': '--ts-color-icon'
    };
    var iconColor = iconColors[variant];
    var loadingColor = loadingColors[variant || ''];
    var buttonClasses = "button ".concat(variant, " ").concat(small ? 'small' : '', " h-stack width-").concat(width, " ").concat(className || '');
    var stackDirection = "".concat(stacked ? 'v-stack' : 'h-stack');
    var renderContent = function () { return (loading ?
        _jsx("div", { style: style, className: "".concat(stackDirection, " background width-").concat(width), children: _jsx(Loader, { color: loadingColor }) })
        :
            _jsxs("div", { style: style, className: "".concat(stackDirection, " background width-").concat(width), children: [iconLeading && _jsx(Icon, { spacing: 'grouped', nested: true, size: "".concat(small ? textStyle.subheadLineHeight : textStyle.bodyLineHeight, "px"), name: iconLeading, color: iconColor, colorCustom: iconLeadingColorCustom }), title && _jsx("p", { className: 'content-view text title1', children: title }), iconTrailing && _jsx(Icon, { spacing: 'grouped', nested: true, size: "".concat(small ? textStyle.subheadLineHeight : textStyle.bodyLineHeight, "px"), name: iconTrailing, color: iconColor })] })); };
    if (children && type !== 'fileUpload' && type !== 'link') {
        // Simple wrapper for children without button styling
        return url ? (_jsx("a", __assign({}, ariaProps, { ref: ref, className: "button-generic width-".concat(width, " ").concat(className), href: url, style: {}, target: target, children: children }))) : (
        // @ts-ignore
        _jsx("button", __assign({}, ariaProps, { ref: ref, type: type, tabIndex: 0, style: {}, onClick: handleClick, className: "button-generic width-".concat(width, " ").concat(className), children: children })));
    }
    if (onFileUpload) {
        return (_jsx(_Fragment, { children: _jsxs("label", { className: "v-stack width-".concat(width, " height-hug ").concat(className), children: [_jsx("input", { ref: fileInputRef, type: 'file', style: { display: 'none' }, onChange: handleFileChange }), _jsx("button", __assign({ style: style }, ariaProps, { ref: ref, type: 'button', onClick: handleClick, className: buttonClasses, children: renderContent() }))] }) }));
    }
    return url ? (
    // <div className='touch-region'>
    _jsx("a", __assign({}, ariaProps, { ref: ref, className: buttonClasses, href: url, onClick: handleClick, style: __assign({}, buttonStyles), target: target, children: renderContent() }))
    // </div>
    ) : (
    // <div className='touch-region'>
    _jsx("button", __assign({}, ariaProps, { ref: ref, 
        // @ts-ignore
        type: type, onClick: handleClick, style: __assign({}, buttonStyles), className: buttonClasses, children: renderContent() }))
    // </div>
    );
};
ButtonInner.displayName = "Button";
export var Button = React.forwardRef(ButtonInner);
